import { take, put } from "redux-saga/effects";
import { GET_BOOK_TYPES_LIST, getBookTypesListActions } from "src/redux/actions/book";

// services
import { getTagList } from "src/services/http/book";

// types
import { GetCategoryListResponseTypes, GetTagListRequestTypes } from "../../actions/book/types";

import * as Effects from "redux-saga/effects";

const call: any = Effects.call;

function* watchGetBookTypesListRequest() {
  while (true) {
    const { payload }: IActionType<GetTagListRequestTypes> = yield take(GET_BOOK_TYPES_LIST.REQUEST);

    const { onSuccess, ...restPayload } = payload as GetTagListRequestTypes;

    try {
      const result: GetCategoryListResponseTypes = yield call(getTagList, restPayload);
      yield put(getBookTypesListActions.success(result));

      if (onSuccess && result.length > 0) {
        onSuccess(result);
      }
    } catch (e) {
      console.log(e, "error");
      yield put(getBookTypesListActions.error(e as any));
    }
  }
}

export default watchGetBookTypesListRequest;
